import { Box, BoxProps } from "@mui/material";

interface Props extends BoxProps {
    width?: number;
}

export default function LogoCustomSize({ width = 106, sx }: Props) {
    return (
        <Box sx={{ width: width, height: width * 0.53773, ...sx }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106 57">
                <path
                    d="M0 0l31.5 3.2c9.3 .2 17.3 5.4 21.5 12.9c4.2-7.5 12.2-12.7 21.5-12.9l31.5-3.2l-5.6 32.1v-0.1c-1.8 12.2-12.4 21.5-25.2 21.5c-5.7 0-11-1.9-15.3-5.1l-7.2 8.6l-7-8.3c-4.2 3-9.4 4.8-14.9 4.8c-12.8 0-23.4-9.3-25.2-21.5v.1Zm30.9 10.4c-10.1 0-18.3 8.1-18.3 18c0 10 8.2 18.1 18.3 18.1c10.1 0 18.2-8.1 18.2-18.1c0-9.9-8.1-18-18.2-18Zm62.5 18c0-9.9-8.2-18-18.3-18c-10.1 0-18.2 8.1-18.2 18c0 10 8.1 18.1 18.2 18.1c10.1 0 18.3-8.1 18.3-18.1Zm-55.4-3.3h-7c0 0-0.1 0-0.1-0.1v-7.1c0-1.1-0.4-1.3-0.7-1.3c-0.3 0-0.6 .3-1 .9l-6.9 12.5c-0.2 .3-0.2 .7-0.1 .9c.2 .3 .5 .5 .9 .5h6.9c.1 0 .1 0 .1 0v7.2c0 1 .4 1.2 .7 1.2c.4 0 .7-0.2 1-0.8l7-12.6c.2-0.3 .2-0.6 0-0.9c-0.1-0.3-0.4-0.4-0.8-0.4Zm38 0h6.9c.4 0 .7 .1 .9 .4c.1 .3 .1 .6-0.1 .9l-6.9 12.6c-0.4 .6-0.7 .8-1 .8c-0.3 0-0.7-0.2-0.7-1.2v-7.2c0 0-0.1 0-0.1 0h-7c-0.4 0-0.7-0.2-0.8-0.5c-0.2-0.2-0.2-0.6 0-0.9l7-12.5c.3-0.6 .6-0.9 1-0.9c.3 0 .7 .2 .7 1.3v7.1c0 .1 0 .1 .1 .1Z"
                    fillRule="evenodd"
                    fill="#ff5004"
                />
            </svg>
        </Box>
    );
}
